import { overSome, isNull, isUndefined, overEvery, isObject, isEmpty } from 'lodash/fp';
export var isEmptyObject = overSome([isNull, isUndefined, overEvery([isObject, isEmpty])]);
export default isEmptyObject;